import { RootState } from "../..";
import { createSelector } from "@reduxjs/toolkit";
import { arrayToObjectByField } from "Utils";
import { DataStatus } from "../../types";
import { ASSIGNABLE_ROLES } from "Utils/adminUsersAPI";

/**
 * Roles the legacy `/people` picker offers, out of whatever `GET /api/v1/roles/`
 * returns. Both name families are listed while RBAC runs in dual mode: the
 * legacy Django roles and the canonical human roles (`ASSIGNABLE_ROLES`, never
 * the vehicle role) that replace them once `RBAC_LEGACY_ROLES_RETIRED` is on
 * (DEV-6440).
 */
export const AVAILABLE_ROLES: readonly string[] = [
  "Admin",
  "Super Admin",
  "Mission Operator",
  ...ASSIGNABLE_ROLES,
];

export const getRoles = (state: RootState) => state.roles.data;
export const getRolesById = createSelector(getRoles, (roles) =>
  arrayToObjectByField(roles)
);

export const getAvailableRoles = createSelector(getRoles, (roles) => {
  return roles.filter((role) => AVAILABLE_ROLES.includes(role?.name));
});
export const getIsRolesLoaded = (state: RootState): boolean =>
  state.roles.status === DataStatus.succeeded;
export const getIsRolesLoadingFailed = (state: RootState): boolean =>
  state.roles.status === DataStatus.failed;
export const getIsRolesForbidden = (state: RootState): boolean =>
  state.roles.forbidden === true;
